import { styled } from '@mui/system'
import * as React from 'react'
import { Typography } from '@mui/material';
import { useIntl } from 'react-intl'
import InsertLinkTwoToneIcon from '@mui/icons-material/InsertLinkTwoTone';
import { LocalizedLink as Link } from "gatsby-theme-i18n"

const RootDiv = styled('div')({
	padding: "10px 0 10px 0",
	color: "#231f20",
	borderBottom: "1px solid #a4a596",
	cursor: "pointer"
})

const Title = styled(Typography)({
	lineHeight: "19px",
	fontSize: "13px",
	display: 'inline-flex',
	VerticalAlign: 'text-bottom',
	BoxSizing: 'inherit',
	textAlign: 'left',
	AlignItems: 'left'
})


export default function ListLink ({article, handleClickItemLink, inFrise}) {
	const intl = useIntl()

	const LinkDiv = styled((inFrise) ? 'div' : Link)({
		textDecoration: 'none',
		color: "black"
	})

	const handleClick = () => {
		handleClickItemLink(article);
	}

	const LinkDivProps = (inFrise) ?
			{onClick: handleClick}
		:
			{to: `/frise/${article.slug}`};
	
  return (
		<RootDiv>
			<LinkDiv {...LinkDivProps}>
				<Title>
					<InsertLinkTwoToneIcon fontSize="small" sx={{color: "#a4a596"}}/>
					{article.date_start.substring(0, 4) + " - "+ article.translations.find((trans) => (trans.lang === intl.locale)).title}
				</Title>
			</LinkDiv>
		</RootDiv>
  )
}